import { useGetDaasEntities } from '../useGetDaasEntities';

export const useGetDaasProjects = (
  userOwedProjects: boolean = false,
  userInSecurityGroup: boolean = false,
) => {
  return useGetDaasEntities(
    'daas-project',
    userOwedProjects,
    userInSecurityGroup,
  );
};
